import { CircularProgress } from "@mui/material";
import "./spinner.scss";;

const Spinner = () => {
    return(
        <div className="loader">
            <CircularProgress size={50}/>
        </div>
    )
}

export default Spinner;